import React from 'react';
import { H4, H6 } from '../../../AbstractElements';
import ReactApexChart from 'react-apexcharts';
import { Card, CardBody, Col} from 'reactstrap';
import { optionsLineChart } from '../../../Data/Widgets/Chart/ChartData';
import { FiChevronUp } from 'react-icons/fi';

const SaleChart = ({ cardData }) => {
  const newChartData = {
    ...optionsLineChart,
    series: [{ data: cardData.chartSeries }],
    options: {
      ...optionsLineChart.options,
      colors: [cardData.chartColor],
    },
  };
  return (
    <>
      <Col xl='4' md='12' className='box-col-4'>
        <Card className='o-hidden'>
          <div className='chart-widget-top'>
            <CardBody>
              <div className='gap-2 d-flex align-items-start justify-content-between'>
                <div>
                  <H6 className={`f-w-600 font-${cardData.statusColor}`}>{cardData.title}</H6>
                  <span className='num d-flex align-items-center'>
                    <span className='counter'>{cardData.gros}</span>%<FiChevronUp style={{ width: '20px', height: '20px', strokeWidth: '1.1px' }} className='f-12 ms-1' />
                  </span>
                </div>
                <div className='text-end'>
                  <H4 className='num total-value'>
                    <span className='counter'>{cardData.price}</span>
                  </H4>
                </div>
              </div>
            </CardBody>
            <div>
              <div id='chart-widget1'>
                <ReactApexChart options={newChartData.options} series={newChartData.series} height='170' type='area' />
              </div>
            </div>
          </div>
        </Card>
      </Col>
    </>
  );
};
export default SaleChart;
